import { styled } from 'twin.macro'
import Button, { ButtonVariant } from '@components/DesignSystem/Button'
import EditIcon from '@components/Icons/EditIcon'
import { useTranslation } from '@i18n'

const Container = styled.div`
  padding: 20px 0 5px;
  text-align: center;
`

interface CreatePostButtonBlockProps {
  type: 'sex' | 'secret'
}

function CreatePostButtonBlock({ type }: CreatePostButtonBlockProps) {
  const { t } = useTranslation('post')

  return (
    <Container>
      <Button
        variant={ButtonVariant.primary}
        as="a"
        href={`/create-post${type === 'sex' ? '-sex' : ''}`}
      >
        <EditIcon />
        {type === 'sex' ? t('createSexPost') : t('createSecretPost')}
      </Button>
    </Container>
  )
}

export default CreatePostButtonBlock
